import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

// Import Ionic
import { IonCol, IonIcon, IonImg, IonRow, IonText } from "@ionic/react";

// Import Icons
import { basketOutline, heartOutline, locationSharp, personOutline } from "ionicons/icons";

// Import Styles
import classNames from "classnames/bind";
import styles from "./ToolbarDesktop.module.scss";

// Import Components
import { SearchBox } from "../../SearchBox/SearchBox";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";
import { useAuth } from "../../../contexts/auth-context";
import Images from "@core/images";
import { useConfig } from "../../../providers/config";
import { applyRegExOnPhoneNumber } from "../../../providers/utils/utils";
import { useCartData } from "../../../providers/cartDataStore";
import { SelectShippingZone } from "../../SelectShippingZone/SelectShippingZone";
import { CurrentShippingAddress } from "../../CurrentShippingAddress/CurrentShippingAddress";
import ExpressMarketSwitcher from "../../ExpressMarketSwitcher/ExpressMarketSwitcher";
import { ExpressSearchBox } from "../../ExpressSearchBox/ExpressSearchBox";
import { DropdownCatalog } from "../../DropdownCatalog";
import promotionIcon from "../../../assets/icon/promotion.svg";
import { CustomerAddressSelectProvider } from "../../../providers/CustomerAddresses/CustomerAddressesStateContext";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

export interface IToolbarDesktop {
  showShippingZone?: boolean;
  showShippingCurrentAddress?: boolean;
  breadcrumbs?: { title: string; handler?: () => void }[];
}

const ToolbarDesktop: React.FC<IToolbarDesktop> = ({ breadcrumbs, showShippingZone, showShippingCurrentAddress }) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const history = useHistory();
  const { cartTotalValue, cartProducts } = useCartData();

  const { user } = useAuth();
  const config = useConfig();

  const goToPage = (path: string) => {
    history.push(path);
  };

  const goToMyAccount = () => {
    if (!!user) {
      goToPage("/my-account");
    } else {
      if (!pathname.startsWith("/login")) {
        goToPage("/auth");
      }
    }
  };

  const isDefaultShippingZoneEnabled = useMemo(() => {
    return config?.shipping.isShippingZonesEnabled && config?.shipping.showDefaultShippingZone;
  }, [config?.shipping.isShippingZonesEnabled, config?.shipping.showDefaultShippingZone]);

  return (
    <CustomerAddressSelectProvider>
      <div className={cx("toolbarDesktop", "ion-align-items-center", "ion-hide-md-down")}>
        <div className="w-full relative mx-auto">
          <div className={cx("ion-align-items-center", "toolbarDesktopWrapper")}>
            {config?.isExpressDeliveryEnabled ? (
              <>
                <IonRow className="flex items-center justify-between p-2.5 bg-[#282828]">
                  <IonCol className="flex items-center gap-1.5 max-w-sm">
                    <IonIcon className="text-[#BDBDBD] " src={locationSharp} name="location" />
                    <CurrentShippingAddress selectColor="!text-[#BDBDBD]" />
                  </IonCol>
                  <IonCol>
                    <ExpressMarketSwitcher />
                  </IonCol>
                  <IonCol size="auto">
                    <a
                      className="text-white text-sm font-bold"
                      href={`tel:+${applyRegExOnPhoneNumber(config?.companyPhoneNumber || "")}`}
                    >
                      {config?.companyPhoneNumber}
                    </a>
                  </IonCol>
                </IonRow>
                {/* {showShippingCurrentAddress && (
                <>
                  <IonRow className="flex items-center mb-4 py-2 px-5 bg-[#EBEBEB]">
                    <IonCol className="flex-[1_1_16rem]">
                      <input
                        type="text"
                        placeholder="Адрес"
                        className=" pl-3.5 py-4 w-full rounded-md border-1 border-solid border-[#D0D0D0] "
                      />
                    </IonCol>
                    <IonCol className="w-24">
                      <input
                        type="text"
                        placeholder="Дом"
                        className="pl-3.5 py-4 w-full rounded-md border-1 border-solid border-[#D0D0D0] "
                      />
                    </IonCol>
                    <IonCol className="w-24">
                      <input
                        className="pl-3.5 py-4 w-full rounded-md border-1 border-solid border-[#D0D0D0] "
                        type="text"
                        placeholder="Корпус"
                      />
                    </IonCol>
                    <IonCol className="w-24">
                      <input
                        className="pl-3.5 py-4 w-full rounded-md border-1 border-solid border-[#D0D0D0] "
                        type="text"
                        placeholder="Строение"
                      />
                    </IonCol>
                    <IonCol className="w-24">
                      <input
                        className="pl-3.5 py-4 w-full rounded-md border-1 border-solid border-[#D0D0D0] "
                        type="text"
                        placeholder="Этаж"
                      />
                    </IonCol>
                    <IonCol className="w-24">
                      <input
                        className="pl-3.5 py-4 w-full rounded-md border-1 border-solid border-[#D0D0D0] "
                        type="text"
                        placeholder="Квартира"
                      />
                    </IonCol>
                    <IonCol className="w-24">
                      <button className="border-1 border-solid rounded-md py-3.5 px-7 border-white text-black bg-[#EABC2E]">
                        Выбрать
                      </button>
                    </IonCol>
                  </IonRow>
                  <InputToolbar />
                </>
              )} */}
              </>
            ) : (
              <IonRow className={cx("toolbarTop")}>
                <IonCol size="auto" className={cx("toolbarLogoWrapper")}>
                  <IonImg
                    src={Images.logo}
                    alt={t("Home")}
                    className={cx("toolbarLogo")}
                    onClick={() => {
                      goToPage("/home3");
                    }}
                  />
                </IonCol>
                <IonCol className="flex">
                  {showShippingZone && isDefaultShippingZoneEnabled && <SelectShippingZone interfaceType="popover" />}
                  {showShippingCurrentAddress && <CurrentShippingAddress />}
                </IonCol>
                <IonCol size="auto">
                  <a
                    href={`tel:+${applyRegExOnPhoneNumber(config?.companyPhoneNumber || "")}`}
                    className={cx("toolbarPhone")}
                  >
                    {config?.companyPhoneNumber}
                  </a>
                </IonCol>
              </IonRow>
            )}
            {config?.isExpressDeliveryEnabled ? (
              <IonRow className="flex items-center justify-between gap-8 py-2.5 px-3.5 bg-white ">
                <IonCol size="auto" className="h-[4.5rem]">
                  <IonImg
                    src={Images.logo}
                    className="block h-full w-auto -ml-[0.55rem]"
                    alt={t("Home")}
                    onClick={() => {
                      goToPage("/home3");
                    }}
                  />
                </IonCol>
                <IonCol size="auto" className="flex items-center !flex-1">
                  <DropdownCatalog />
                  <ExpressSearchBox />
                </IonCol>
                <IonCol className={cx("toolbarIcons", "flex items-center gap-5")} size="auto">
                  <div
                    className={cx("flex items-center cursor-pointer")}
                    title={t("Promotions")}
                    onClick={() => {
                      goToPage("/categories/6910/subcategories");
                    }}
                  >
                    <IonIcon icon={promotionIcon} />
                    <IonText className="hidden lg:block">{t("Promotions")}</IonText>
                  </div>
                  <div
                    className={cx("flex items-center cursor-pointer")}
                    title={t("Favorite")}
                    onClick={() => {
                      goToPage("/wish-list");
                    }}
                  >
                    <IonIcon icon={heartOutline} />
                    <IonText className="hidden lg:block">{t("Favorite")}</IonText>
                  </div>
                  <div className={cx("flex items-center cursor-pointer")} title={t("Profile")} onClick={goToMyAccount}>
                    <IonIcon icon={personOutline} />
                    <IonText className="hidden lg:block">{t("Profile")}</IonText>
                  </div>
                  <div
                    className={cx("toolbarIconBasketWrapper")}
                    onClick={() => {
                      goToPage("/cart");
                    }}
                  >
                    <div className={cx("toolbarIcon", "toolbarIconBasket")} title={t("My Cart")}>
                      <IonIcon icon={basketOutline} />
                      <div className={cx("toolbarIconBasketBadge")}>
                        <span>{cartProducts.reduce((acc, item) => item.quantity + acc, 0).toFixed(2)}</span>
                      </div>
                    </div>
                    <span className={cx("toolbarIconSum")}>&#x20bd;{cartTotalValue.toFixed(2)}</span>
                  </div>
                </IonCol>
              </IonRow>
            ) : (
              <IonRow className={cx("toolbarBottom")}>
                <IonCol size="auto" className={cx("toolbarCatalog")}>
                  <span
                    onClick={() => {
                      goToPage("/search-main-categories");
                    }}
                  >
                    {t("Catalog of goods")}
                  </span>
                </IonCol>
                <IonCol className={cx("toolbarSearch")}>
                  <SearchBox />
                </IonCol>
                <IonCol className={cx("toolbarIcons")} size="auto">
                  <div
                    className={cx("toolbarIcon", "toolbarIconWish")}
                    title={t("Favorite")}
                    onClick={() => {
                      goToPage("/wish-list");
                    }}
                  >
                    <IonIcon icon={heartOutline} />
                  </div>
                  <div className={cx("toolbarIcon", "toolbarIconUser")} title={t("Profile")} onClick={goToMyAccount}>
                    <IonIcon icon={personOutline} />
                  </div>
                  <div
                    className={cx("toolbarIconBasketWrapper")}
                    onClick={() => {
                      goToPage("/cart");
                    }}
                  >
                    <div className={cx("toolbarIcon", "toolbarIconBasket")} title={t("My Cart")}>
                      <IonIcon icon={basketOutline} />
                      <div className={cx("toolbarIconBasketBadge")}>
                        <span>{cartProducts.reduce((acc, item) => item.quantity + acc, 0).toFixed(2)}</span>
                      </div>
                    </div>
                    <span className={cx("toolbarIconSum")}>&#x20bd;{cartTotalValue.toFixed(2)}</span>
                  </div>
                </IonCol>
              </IonRow>
            )}
          </div>
          {!!breadcrumbs?.length && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        </div>
      </div>
    </CustomerAddressSelectProvider>
  );
};

export default ToolbarDesktop;
